import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M8.797 18.797a8 8 0 0 0 7.597 2.104l.179-.044c1.508-.377 2.028-2.255.93-3.355l-2.228-2.227A1.478 1.478 0 0 0 13 15.5a1.478 1.478 0 0 1-2.275.225l-2.45-2.45A1.478 1.478 0 0 1 8.5 11a1.478 1.478 0 0 0 .225-2.275L6.498 6.498c-1.1-1.1-2.978-.58-3.355.929l-.045.179a8 8 0 0 0 2.105 7.597z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 7a5 5 0 0 1-5 5h-4.5a.5.5 0 0 1-.5-.5V7a5 5 0 0 1 10 0m-7.8-1a1 1 0 0 1 1-1h3.6a1 1 0 1 1 0 2h-3.6a1 1 0 0 1-1-1M14 9a1 1 0 0 1 1-1h1.4a1 1 0 0 1 0 2H15a1 1 0 0 1-1-1",
      clipRule: "evenodd"
    }
  )
);
var SvgClickToContactFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ClickToContactFilled_default = SvgClickToContactFilled;

export { ClickToContactFilled_default as default };
